export default __webpack_public_path__ + "resources/icons/n320-b57c.png";